import { styled } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import AdNavBar from "src/components/common/AdNavBar";
import AdAppModal from "src/components/modals/AppModal";
import ExtraModal from "src/components/modals/ExtraModal";


const PageCommonStyle = styled('div',{
  shouldForwardProp: (prop) => prop !== 'isExactAdminPage',
})<{ isExactAdminPage: boolean }>(({ theme, isExactAdminPage })=>({
  paddingTop: '76px', 
  paddingLeft: !isExactAdminPage ? '320px':'0px', 
  backgroundColor:'#F5F5F5', 
  width:'100%', 
  height:'100vh'
}))

const AdminLayout = () => {
  const location = useLocation()
  const isExactAdminPage = location.pathname === '/admin';
    return (
      <>
        <ToastContainer />
        <AdNavBar />
        <AdAppModal />
        <ExtraModal/>
        <PageCommonStyle isExactAdminPage={isExactAdminPage}>
          <Outlet />
        </PageCommonStyle>
      </>
    );
  };
  
export default AdminLayout;